// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.my-ballots-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.85);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    padding: 20px;
    backdrop-filter: blur(8px);
}

.my-ballots-modal-content {
    background: #0e1b1b;
    width: 100%;
    max-width: 650px;
    max-height: 85vh;
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    border: 1px solid rgba(255, 255, 255, 0.1);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
    animation: modalFadeIn 0.3s ease-out;
}

@keyframes modalFadeIn {
    from {
        opacity: 0;
        transform: translateY(20px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.my-ballots-modal-header {
    padding: 20px 25px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}

.header-text h3 {
    margin: 0;
    color: #fff;
    font-size: 20px;
    font-weight: 600;
}

.parent-title {
    margin: 5px 0 0 0;
    color: #5aaf9a;
    font-size: 13px;
    opacity: 0.8;
}

.close-btn {
    background: none;
    border: none;
    color: rgba(255, 255, 255, 0.6);
    cursor: pointer;
    padding: 5px;
    border-radius: 50%;
    transition: all 0.2s;
}

.close-btn:hover {
    background: rgba(255, 255, 255, 0.1);
    color: #fff;
}

.my-ballots-modal-body {
    flex: 1 1;
    overflow-y: auto;
    padding: 25px;
    scrollbar-width: thin;
    scrollbar-color: #5aaf9a transparent;
}

.my-ballots-modal-body::-webkit-scrollbar {
    width: 6px;
}

.my-ballots-modal-body::-webkit-scrollbar-thumb {
    background-color: #5aaf9a;
    border-radius: 10px;
}

.modal-loader-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 15px;
    color: rgba(255, 255, 255, 0.7);
    padding: 40px 0;
}

.sub-ballots-list {
    display: flex;
    flex-direction: column;
    gap: 25px;
}

.sub-ballot-card {
    background: rgba(255, 255, 255, 0.03);
    padding: 20px;
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.05);
}

.sub-ballot-q {
    margin: 0 0 15px 0;
    color: #fff;
    font-size: 16px;
    line-height: 1.4;
}

.sub-ballot-options {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.sub-opt-row {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.sub-opt-info {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
}

.sub-opt-val {
    color: rgba(255, 255, 255, 0.9);
}

.sub-opt-perc {
    color: #5aaf9a;
    font-weight: 600;
}

.sub-opt-progress {
    height: 8px;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 4px;
    overflow: hidden;
}

.sub-opt-fill {
    height: 100%;
    background: #5aaf9a;
    border-radius: 4px;
    transition: width 0.6s ease;
}

.no-sub-ballots {
    text-align: center;
    color: rgba(255, 255, 255, 0.5);
    padding: 40px 0;
}

.my-ballots-modal-footer {
    padding: 20px 25px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    display: flex;
    justify-content: flex-end;
}

.confirm-btn {
    background: #5aaf9a;
    color: #fff;
    border: none;
    padding: 10px 30px;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
}

.confirm-btn:hover {
    background: #4a9180;
    transform: translateY(-1px);
}

@media (max-width: 480px) {
    .my-ballots-modal-content {
        max-height: 90vh;
    }

    .my-ballots-modal-header {
        padding: 15px 20px;
    }

    .my-ballots-modal-body {
        padding: 15px 20px;
    }
}`, "",{"version":3,"sources":["webpack://./src/Components/MyBallots/MyBallotsModal.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,+BAA+B;IAC/B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,0CAA0C;IAC1C,0CAA0C;IAC1C,oCAAoC;AACxC;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,kBAAkB;IAClB,iDAAiD;IACjD,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,SAAS;IACT,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,+BAA+B;IAC/B,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,oCAAoC;IACpC,WAAW;AACf;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,qBAAqB;IACrB,oCAAoC;AACxC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,qCAAqC;IACrC,aAAa;IACb,mBAAmB;IACnB,2CAA2C;AAC/C;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,qCAAqC;IACrC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,8CAA8C;IAC9C,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;AACJ","sourcesContent":[".my-ballots-modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.85);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n    padding: 20px;\n    backdrop-filter: blur(8px);\n}\n\n.my-ballots-modal-content {\n    background: #0e1b1b;\n    width: 100%;\n    max-width: 650px;\n    max-height: 85vh;\n    border-radius: 20px;\n    display: flex;\n    flex-direction: column;\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);\n    animation: modalFadeIn 0.3s ease-out;\n}\n\n@keyframes modalFadeIn {\n    from {\n        opacity: 0;\n        transform: translateY(20px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.my-ballots-modal-header {\n    padding: 20px 25px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n}\n\n.header-text h3 {\n    margin: 0;\n    color: #fff;\n    font-size: 20px;\n    font-weight: 600;\n}\n\n.parent-title {\n    margin: 5px 0 0 0;\n    color: #5aaf9a;\n    font-size: 13px;\n    opacity: 0.8;\n}\n\n.close-btn {\n    background: none;\n    border: none;\n    color: rgba(255, 255, 255, 0.6);\n    cursor: pointer;\n    padding: 5px;\n    border-radius: 50%;\n    transition: all 0.2s;\n}\n\n.close-btn:hover {\n    background: rgba(255, 255, 255, 0.1);\n    color: #fff;\n}\n\n.my-ballots-modal-body {\n    flex: 1;\n    overflow-y: auto;\n    padding: 25px;\n    scrollbar-width: thin;\n    scrollbar-color: #5aaf9a transparent;\n}\n\n.my-ballots-modal-body::-webkit-scrollbar {\n    width: 6px;\n}\n\n.my-ballots-modal-body::-webkit-scrollbar-thumb {\n    background-color: #5aaf9a;\n    border-radius: 10px;\n}\n\n.modal-loader-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 15px;\n    color: rgba(255, 255, 255, 0.7);\n    padding: 40px 0;\n}\n\n.sub-ballots-list {\n    display: flex;\n    flex-direction: column;\n    gap: 25px;\n}\n\n.sub-ballot-card {\n    background: rgba(255, 255, 255, 0.03);\n    padding: 20px;\n    border-radius: 12px;\n    border: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.sub-ballot-q {\n    margin: 0 0 15px 0;\n    color: #fff;\n    font-size: 16px;\n    line-height: 1.4;\n}\n\n.sub-ballot-options {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.sub-opt-row {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n.sub-opt-info {\n    display: flex;\n    justify-content: space-between;\n    font-size: 14px;\n}\n\n.sub-opt-val {\n    color: rgba(255, 255, 255, 0.9);\n}\n\n.sub-opt-perc {\n    color: #5aaf9a;\n    font-weight: 600;\n}\n\n.sub-opt-progress {\n    height: 8px;\n    background: rgba(255, 255, 255, 0.05);\n    border-radius: 4px;\n    overflow: hidden;\n}\n\n.sub-opt-fill {\n    height: 100%;\n    background: #5aaf9a;\n    border-radius: 4px;\n    transition: width 0.6s ease;\n}\n\n.no-sub-ballots {\n    text-align: center;\n    color: rgba(255, 255, 255, 0.5);\n    padding: 40px 0;\n}\n\n.my-ballots-modal-footer {\n    padding: 20px 25px;\n    border-top: 1px solid rgba(255, 255, 255, 0.1);\n    display: flex;\n    justify-content: flex-end;\n}\n\n.confirm-btn {\n    background: #5aaf9a;\n    color: #fff;\n    border: none;\n    padding: 10px 30px;\n    border-radius: 8px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.confirm-btn:hover {\n    background: #4a9180;\n    transform: translateY(-1px);\n}\n\n@media (max-width: 480px) {\n    .my-ballots-modal-content {\n        max-height: 90vh;\n    }\n\n    .my-ballots-modal-header {\n        padding: 15px 20px;\n    }\n\n    .my-ballots-modal-body {\n        padding: 15px 20px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
